module.exports = __webpack_public_path__ + "img/edition_2.6dc280ee.png";